import parkingBookingService from '@/api/parkingbooking'

export default {
  namespaced: true,
  actions: {
    async deleteParkingBookingOfAnUser ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await parkingBookingService.deleteParkingBookingOfAnUser(payload.parking.id, payload.booking.id)
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    markParkingBookingAsCheckedOutOfAnUser: function ({dispatch}, payload) {
      return new Promise((resolve, reject) => {
      parkingBookingService.markParkingBookingAsCheckedOutOfAnUser(payload.parking.id, payload.booking.id).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(
          dispatch('Global/hideLoading', null, {root: true})
        )
      })
    }
  }
}
